import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';
import { StaffNotesDtoSchema } from '../contracts';

export const GetStaffNoteResponseDtoSchema =
  PagePaginationResponseDtoSchema(StaffNotesDtoSchema);

export type GetStaffNoteRequestDto = PagePaginationRequestDto<
  { id: number },
  'creationDate' | 'takenBy'
>;
export type GetStaffNoteResponseDto = z.infer<
  typeof GetStaffNoteResponseDtoSchema
>;

export const getStaffNotes = (
  params: GetStaffNoteRequestDto,
  config?: AxiosRequestConfig<GetStaffNoteRequestDto>
) => {
  const { id, ...restParams } = params;

  return api
    .get(`staff/${id}/notes`, { params: restParams, ...config })
    .then(responseContract(GetStaffNoteResponseDtoSchema));
};
